import React from 'react'
import { HStack, Box, Link, VStack, Text, Flex } from '@chakra-ui/react'
import { CoverImage, PriceLabel } from '@!/Store/Common/components'
import { SampleButton } from '@!/Store/Common/components/BookList/Button'
import { isBlank, buildSearchUrl } from '@!/Util'

export const ListItem = ({ bookTitle }) => {
  const linkUrl = `/store/books?book_title_id=${bookTitle.title_id}`

  // 作者名は5人まで表示
  const authorNames = bookTitle.author_name ? bookTitle.author_name.split(',').slice(0, 5) : null

  const linkStyles = {
    color: 'label.primary',
    fontWeight: '300',
    textDecoration: 'none',
    cursor: 'pointer',
  }

  return (
    <HStack gap={0} w="100%" py="16px" alignItems="flex-start">
      <Link {...linkStyles} href={linkUrl}>
        <CoverImage width="90px" src={bookTitle.image_url} alt={bookTitle.title_name} />
      </Link>
      <VStack gap={0} pl="16px" flex="1" alignItems="start" fontSize="3xs" fontWeight="300" lineHeight="16.5px">
        <Link {...linkStyles} mb="8px" fontSize="md" fontWeight="600" lineHeight="22px" href={linkUrl}>
          {bookTitle.title_name}
        </Link>
        {authorNames && (
          <HStack gap={0} mb="4px" alignItems="flex-start">
            <Text>著者：</Text>
            <Box flex="1">
              {authorNames
                .map((authorName, index) => (
                  <Link key={`list-item-author-name-${index}`} textDecoration="none" href={buildSearchUrl('author', authorName)}>
                    {authorName}
                  </Link>
                ))
                .reduce((prev, curr) => [prev, '、', curr])}
            </Box>
          </HStack>
        )}
        {bookTitle.publisher_name && (
          <HStack gap={0} mb="4px" alignItems="flex-start">
            <Text>出版社：</Text>
            <Box flex="1">
              <Link textDecoration="none" href={buildSearchUrl('publisher', bookTitle.publisher_name)}>
                {bookTitle.publisher_name}
              </Link>
            </Box>
          </HStack>
        )}
        {!isBlank(bookTitle.sub_genre_names) && (
          <HStack gap={0} mb="4px" alignItems="flex-start">
            <Text>ジャンル：</Text>
            <Box flex="1">
              {bookTitle.sub_genre_names
                .map((subGenreName, index) => (
                  <Link key={`list-item-subgenre-name-${index}`} textDecoration="none" href={buildSearchUrl('category', subGenreName)}>
                    {subGenreName}
                  </Link>
                ))
                .reduce((prev, curr) => [prev, '、', curr])}
            </Box>
          </HStack>
        )}
        {bookTitle.label_name && (
          <HStack gap={0} mb="4px" alignItems="flex-start">
            <Text>レーベル：</Text>
            <Box flex="1">
              <Link textDecoration="none" href={buildSearchUrl('label', bookTitle.label_name)}>
                {bookTitle.label_name}
              </Link>
            </Box>
          </HStack>
        )}
        {!isBlank(bookTitle.price) && <PriceLabel price={bookTitle.price} />}
        {bookTitle?.first_volume?.sample_content_id &&
          bookTitle?.first_volume?.sample_file_path &&
          bookTitle?.first_volume?.price !== 0 &&
          !bookTitle?.first_volume?.purchased && (
            <Flex w="100%" justifyContent="flex-end">
              <Box w="124px" h="37px">
                <SampleButton
                  contentId={bookTitle.first_volume.content_id}
                  sampleBookId={bookTitle.first_volume.sample_content_id}
                  sampleFilePath={bookTitle.first_volume.sample_file_path}
                  adult_flag={bookTitle.adult_flag}
                  price={bookTitle.first_volume.price}
                  isPurchased={bookTitle.first_volume.purchased}
                />
              </Box>
            </Flex>
          )}
      </VStack>
    </HStack>
  )
}
